const someJson = [
    {
      "title": "Buy groceries"
    },
    {
      "title": "Clean the house"
    },
    {
      "title": "Pay bills"
    },
    {
      "title": "Go for a walk"
    },
    {
      "title": "Study for an exam"
    },
    {
      "title": "Call a friend"
    },
    {
      "title": "Cook dinner"
    },
    {
      "title": "Do the laundry"
    },
    {
      "title": "Water the plants"
    },
    {
      "title": "Organize the desk"
    }
  ]
  
  
  
  export default someJson